var StatisticsModule = /** @class */ (function () {
    function StatisticsModule() {
    }
    return StatisticsModule;
}());
export { StatisticsModule };
